module.exports = __webpack_public_path__ + "static/media/karen-willsey.0a37f682.jpeg";